export default __webpack_public_path__ + "static/media/Emily.da676ca0.jpg";